<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    width="500px"
    class="c-InvoiceEdit-sns"
    :title="`${!invoiceInfo ? '新增' : '修改'}增值税专用发票`"
    :close-on-click-modal="false"
    @close="$emit('update:visible', false)"
    :height="604"
  >
    <h4>
      公司信息
    </h4>
    <el-row>
      <znl-input
        :border="true"
        title="单位名称:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.InvoiceCompanyName"
      ></znl-input>
    </el-row>
    <el-row>
      <znl-input
        :border="true"
        title="税务登记号:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.InvoiceCode"
      ></znl-input>
    </el-row>
    <el-row>
      <znl-input
        :border="true"
        title="注册地址:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.CompanyAddress"
      ></znl-input>
    </el-row>
    <el-row>
      <znl-input
        :border="true"
        title="注册电话:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.CompanyMoblie"
      ></znl-input>
    </el-row>
    <el-row>
      <znl-input
        :border="true"
        title="开户银行:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.InvoiceOpenBank"
      ></znl-input>
    </el-row>
    <el-row>
      <znl-input
        :border="true"
        title="银行账户:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.InvoiceBankAccountNumber"
      ></znl-input>
    </el-row>

    <h4>
      收票人信息
    </h4>
    <el-row>
      <znl-input
        :border="true"
        title="收票人姓名:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.CollectorName"
      ></znl-input>
    </el-row>
    <el-row>
      <znl-input
        :border="true"
        title="电话号码:"
        title-width="80px"
        width="100%"
        v-model="submitInvoiceInfo.CollectorMoblie"
      ></znl-input>
    </el-row>
    <el-row class="multiple-inputs">
      <znl-input
        :border="true"
        title="地址信息:"
        title-width="80px"
        width="200px"
        form-type="select"
        :select-options="provinces"
        v-model="submitInvoiceInfo.CollectorProvince"
        @change="submitInvoiceInfo.CollectorCity = ''; submitInvoiceInfo.CollectorCounty = ''"
      ></znl-input>

      <znl-input
        :border="true"
        title-width="80px"
        width="120px"
        form-type="select"
        :select-options="cities"
        v-model="submitInvoiceInfo.CollectorCity"
        @change="submitInvoiceInfo.CollectorCounty = ''"
      ></znl-input>

      <znl-input
        :border="true"
        title-width="80px"
        width="120px"
        form-type="select"
        :select-options="counties"
        v-model="submitInvoiceInfo.CollectorCounty"
      ></znl-input>
    </el-row>
    <el-row class="last-row">
      <znl-input
        :border="true"
        title="详细地址:"
        title-width="80px"
        width="100%"
        type="textarea"
        v-model="submitInvoiceInfo.CollectorDetailed"
      ></znl-input>
    </el-row>

    <div slot="footer">
      <znl-button
        :width="80"
        :height="30"
        @click="$emit('update:visible', false)"
      >取消</znl-button>
      <znl-button
        class="ml10"
        :width="80"
        :height="30"
        style-type="main"
        @click="addUpdateInvoice"
      >保存</znl-button>
    </div>
  </znl-dialog>
</template>
<script>
import { ChinaProvinceCity } from '../../assets/scripts/China_Province_City';
import { httpPost } from '../../assets/scripts/http';

export default {
  name: 'InvoiceEdit',
  props: {
    visible: Boolean,
    invoiceInfo: Object,
    getInvoice: Function
  },
  data() {
    return {
      submitInvoiceInfo: {
        InvoiceCompanyName: '', // 单位名称
        InvoiceCode: '', // 税务登记号
        CompanyMoblie: '', // 注册电话
        InvoiceOpenBank: '', // 注册银行
        InvoiceBankAccountNumber: '', // 银行账户
        CollectorName: '', // 售票人姓名
        CollectorMoblie: '', // 售票人电话
        CollectorProvince: '',
        CollectorCity: '',
        CollectorCounty: '',
        CollectorDetailed: '' // 详细地址
      }
    };
  },
  computed: {
    provinces() {
      return ChinaProvinceCity.map(item => {
        return {
          key: item.name,
          value: item.name
        };
      });
    },
    cities() {
      const ProvinceInfo = ChinaProvinceCity.find(item => {
        return item.name === this.submitInvoiceInfo.CollectorProvince;
      });
      if (ProvinceInfo) {
        return ProvinceInfo.cityList.map(item => {
          return {
            key: item.name,
            value: item.name
          };
        });
      }
      return [];
    },
    counties() {
      const ProvinceInfo = ChinaProvinceCity.find(item => {
        return item.name === this.submitInvoiceInfo.CollectorProvince;
      });
      let cityInfo = null;
      if (ProvinceInfo) {
        cityInfo = ProvinceInfo.cityList.find(item => {
          return item.name === this.submitInvoiceInfo.CollectorCity;
        });
      }
      if (cityInfo) {
        return cityInfo.areaList.map(item => {
          return {
            key: item.name,
            value: item.name
          };
        });
      }
      return [];
    }
  },

  watch: {
    visible(val) {
      if (val && this.invoiceInfo) {
        this.submitInvoiceInfo = Object.assign({}, this.invoiceInfo);
      }
      if (!val) {
        this.submitInvoiceInfo = {
          InvoiceCompanyName: '', // 单位名称
          InvoiceCode: '', // 税务登记号
          CompanyMoblie: '', // 注册电话
          InvoiceOpenBank: '', // 注册银行
          InvoiceBankAccountNumber: '', // 银行账户
          CollectorName: '', // 售票人姓名
          CollectorMoblie: '', // 售票人电话
          CollectorProvince: '',
          CollectorCity: '',
          CollectorCounty: '',
          CollectorDetailed: '' // 详细地址
        };
      }
    }
  },

  methods: {
    addUpdateInvoice() {
      httpPost('bomorder/addUpdateInvoice', this.submitInvoiceInfo).then(
        res => {
          if (res.Code === 0) {
            this.$succMess('设置成功');
            this.$emit('update:visible', false);
            if (this.getInvoice) {
              this.getInvoice();
            }
          } else {
            this.$erroMess(res.Message);
          }
        }
      );
    }
  }
};
</script>
<style lang="scss">
.c-InvoiceEdit-sns {
  .el-row {
    line-height: 40px;
  }
  .last-row {
    margin-top: 6px;
  }
  .multiple-inputs {
    .znl-component-input {
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>